  import {
    UPDATE_PROFILE_REQUEST,
    UPDATE_PROFILE_SUCCESS,
    UPDATE_PROFILE_FAILURE,
  } from '../../../constants/profile/profile';
  
  interface IPersona {
    id: number;
    nombre: string;
    apellidos: string;
  }
  
  interface ISucursal {
    id: number;
    nombre: string;
    direccion: string;
  }
  
  interface ITipoUsuario {
    id: number;
    nombre: string;
  }
  
  interface IEmpresa {
    id: number;
    nombre: string;
  }
  
  export interface IProfile {
    id: number;
    personaId: number;
    tipoUsuarioId: number;
    empresaId: number;
    usuario: string;
    email: string;
    pais?: string;
    telefono?: string;
    imagen_perfil?: string;
    confirmacion: boolean;
    estado: boolean;
    timezone: string;
    createdAt: string;
    updatedAt: string;
    personas?: IPersona;
    tipos_usuarios?: ITipoUsuario;
    empresa?: IEmpresa;
    sucursales?: ISucursal[];
  }
  
  interface ProfileState {
    profile: IProfile | null;
    loading: boolean;
    success: boolean;
    error: string | null;
  }
  
  const INIT_STATE: ProfileState = {
    profile: null,
    loading: false,
    success: false,
    error: null
  };
  
  export default (state = INIT_STATE, action: any): ProfileState => {
    switch (action.type) {  
      case UPDATE_PROFILE_REQUEST:
        return {
          ...state,
          loading: true,
          success: false,
          error: null
        };
  
      case UPDATE_PROFILE_SUCCESS:
        return {
          ...state,
          loading: false,
          success: true,
          profile: action.payload.usuario,
          error: null
        };
  
      case UPDATE_PROFILE_FAILURE:
        return {
          ...state,
          loading: false,
          success: false,
          error: action.payload
        };
  
      default:
        return state;
    }
  };